import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  subTitle: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(20),
  },
  icon: {
    fontSize: theme.fontSize["16"],
    fontWeight: "bold",
  },
  date: {
    color: theme.palette.secondary.tint40,
  },
  emptyText: {
    textAlign: "center",
  },
  coinLogo: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  coinNameAndIcon: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },

  currencyName: {
    marginLeft: theme.spacing(2),
    // whiteSpace: "nowrap !important",
  },
  coinLogoAndText: {
    display: "flex",
    alignItems: "center",
  },
  wrapperLastCol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(7),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: theme.spacing(0, 2),
    },
  },
  bagBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.fontSize["20"],
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      color: "white",
    },
  },
  plusBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.fontSize["20"],
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
  },
  cashOutBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.fontSize["20"],
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.red2.tint12,
      color: theme.palette.red.main,
    },
  },
}));
